import { api } from "../../../../services/Api";
import formatDateBD from "../../../../utils/formatarDataBD";

function formatarDataParametro(data) {
  if (!data) return undefined;

  return formatDateBD(data);
}

export async function buscarRelatoriosAgendaCare({
  dataInicial,
  dataFinal,
  enfermeiroId,
}) {
  const params = {};
  const dataInicialFormatada = formatarDataParametro(dataInicial);
  const dataFinalFormatada = formatarDataParametro(dataFinal);

  if (dataInicialFormatada) {
    params.dataInicial = dataInicialFormatada;
  }

  if (dataFinalFormatada) {
    params.dataFinal = dataFinalFormatada;
  }

  if (enfermeiroId) {
    params.enfermeiroId = enfermeiroId;
  }

  const {
    data: { data },
  } = await api.get("/v2/agendaCare/relatorios", { params });

  return data;
}
